module.exports = __webpack_public_path__ + "static/acquia-7497798ecd5f53952d51db105b4ee685.svg";